export default __webpack_public_path__ + "static/media/dale.8e9cc3a2.png";